import type { SVGProps } from "react";
export interface GridDotsTopIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function GridDotsTopIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: GridDotsTopIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M3 19.867a1.12 1.12 0 0 1 .737.281c.074.065.143.136.198.218a1.12 1.12 0 0 1 0 1.259 1.125 1.125 0 0 1-1.733.165 1.122 1.122 0 0 1 .167-1.729A1.1 1.1 0 0 1 3 19.867m8.997 0A1.127 1.127 0 1 1 12 22.122a1.127 1.127 0 0 1-.002-2.255Zm8.997 0c.234 0 .452.072.632.194a1.124 1.124 0 0 1 .167 1.73 1.122 1.122 0 0 1-1.733-.166 1.12 1.12 0 0 1-.002-1.259c.055-.082.125-.153.2-.218q.05-.046.105-.087l.193-.105c.135-.057.283-.09.438-.09Zm-13.492.003.114.005a1.126 1.126 0 0 1 0 2.239l-.114.006h-.006a1.125 1.125 0 0 1 0-2.25zm8.997 0a1.125 1.125 0 0 1 0 2.25h-.006a1.125 1.125 0 0 1 0-2.25zM1.875 16.499v-.006a1.125 1.125 0 0 1 2.25 0v.006a1.125 1.125 0 0 1-2.25 0m8.997 0v-.006a1.125 1.125 0 0 1 2.25 0v.006a1.125 1.125 0 0 1-2.25 0m8.997 0v-.006a1.126 1.126 0 0 1 2.25 0v.006a1.125 1.125 0 0 1-2.25 0M3 10.869c.235 0 .453.073.633.196a1.117 1.117 0 0 1 .212 1.67 1.12 1.12 0 0 1-1.778-.106 1.12 1.12 0 0 1 .138-1.43c.203-.203.485-.33.795-.33m8.997 0c.235 0 .453.073.633.196a1.125 1.125 0 0 1-.006 1.867 1.12 1.12 0 0 1-1.255 0 1.124 1.124 0 0 1-.006-1.867c.18-.124.4-.195.634-.195Zm8.997 0c.31 0 .592.127.796.33a1.12 1.12 0 0 1 .137 1.43 1.125 1.125 0 0 1-1.561.303 1.1 1.1 0 0 1-.218-.198 1.12 1.12 0 0 1-.281-.737 1.126 1.126 0 0 1 1.127-1.127Zm-13.492.004.114.005a1.126 1.126 0 0 1 0 2.239l-.114.006h-.006a1.125 1.125 0 0 1 0-2.25zm8.997 0 .114.005a1.125 1.125 0 0 1 0 2.239l-.114.006h-.006a1.126 1.126 0 0 1 0-2.25zM1.875 7.502v-.006a1.125 1.125 0 0 1 2.25 0v.006a1.126 1.126 0 0 1-2.25 0m8.997 0v-.006a1.125 1.125 0 0 1 2.25 0v.006a1.126 1.126 0 0 1-2.25 0m8.997 0v-.006a1.125 1.125 0 0 1 2.25 0v.006a1.126 1.126 0 0 1-2.25 0M21 1.875a1.125 1.125 0 0 1 0 2.25H3a1.125 1.125 0 0 1 0-2.25z"
      />
    </svg>
  );
}
